<template>
  <v-col class="my-1 py-0" cols="12" :md="width">
    <p class="mb-1 text-caption">
      <slot name="label" />
    </p>

    <template v-if="important">
      <p class="display-1 accent--text">
        <slot name="value" />
      </p>
    </template>

    <template v-else>
      <p>
        <b><slot name="value" /></b>
      </p>
    </template>

  </v-col>
</template>

<script>
  export default {
    
    props: {

      important: {
        type: Boolean,
        default: false
      },

      width: {
        type: String,
        default: '12'
      },

    },

  }
</script>

<style lang="scss" scoped>

</style>
